Vue.component('ack-pre-reset-password', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-pre-reset-password',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-pre-reset-password mounted');
		this.setPageIsLoading(false);
	},
	props: {},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'pre-reset-password-page',
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		handleClick() {
			window.open('https://dashboard.ackuretta.com/password-reset', '_blank');
			window.location.href = '/account/login';
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
